import { FilterPartOfChip } from "./FilterPartOfChip";
import { FilterPartOfSelector } from "./FilterPartOfSelector";

export const FilterSection: React.FC = () => {
  return (
    <section style={{ display: "flex", flex: 1, alignItems: "center", overflow: "auto" }}>
      <FilterPartOfChip />
      <FilterPartOfSelector />
    </section>
  );
};
